<div class="full-page w-100">
  <div class="container">
    <div class="d-flex justify-content-center">
      <img alt="" [height]="100" src="assets/images/logo.svg" class="logo mb-5" />
    </div>

    <!--Right Side-->
    <div class="bg-white rounded-4 right-side-login text-center">
      <div class="text-primary icon material-icons">engineering</div>
      <h5
        class="text-primary text-center text-uppercase fw-bold mt-4 mb-0"
        [innerHTML]="'maintenance.page.title' | translate | markdownTranslate"
      ></h5>
      <p class="font-size-14" [innerHTML]="'maintenance.page.details' | translate | markdownTranslate"></p>
    </div>
  </div>
</div>
